module.exports = __webpack_public_path__ + "img/slide3.7fd48acd.png";